import $ from "jquery";
var geocodeAndUpdateField = function () {
    var latitude = parseFloat($('#id_latitude_coordonnate').val());
    var longitude = parseFloat($('#id_longitude_coordonnate').val());
    if (!isNaN(latitude) && !isNaN(longitude)) {
        var latlng = new google.maps.LatLng(latitude, longitude);
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'location': latlng }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK && results[0]) {
                var adresseGeocodeeField = $('#id_adresse_geocodee');
                var geocodeData = {
                    address_components: results[0].address_components,
                    formattedAddress: results[0].formatted_address,
                    latitude: latitude,
                    longitude: longitude,
                };
                var geocodeDataJSON = JSON.stringify(geocodeData);
                adresseGeocodeeField.val(geocodeDataJSON);
            }
        });
    }
};
export var ManageProjectOtherAddress = function () {
    /*global google*/
    /*eslint no-undef: "error"*/
    $(document).ready(function () {
        var addressInputForm = document.getElementById("address-input-form-project");
        if (addressInputForm) {
            var inputTypeRadios = document.querySelectorAll('input[name="input_type"]');
            var addressContainer_1 = document.getElementById('address-form-container');
            var coordonnateContainer_1 = document.getElementById('coordonnate-form-container');
            var toggleForms_1 = function () {
                var selectedRadio = document.querySelector('input[name="input_type"]:checked');
                var selectedType = selectedRadio ? selectedRadio.value : 'none';
                if (selectedType === 'address') {
                    addressContainer_1.style.display = 'block';
                    coordonnateContainer_1.style.display = 'none';
                }
                else if (selectedType === 'coordinates') {
                    addressContainer_1.style.display = 'none';
                    coordonnateContainer_1.style.display = 'block';
                }
                else {
                    // Si 'none' est sélectionné
                    addressContainer_1.style.display = 'none';
                    coordonnateContainer_1.style.display = 'none';
                }
            };
            inputTypeRadios.forEach(function (radio) {
                radio.addEventListener('change', toggleForms_1);
            });
            // Initialiser l'affichage
            toggleForms_1();
            var exempleSpan_1 = document.getElementById('coord-exemple');
            var toggleExemple_1 = function () {
                var selectedRadio = document.querySelector('input[name="input_type"]:checked');
                if (selectedRadio && selectedRadio.value === 'coordinates') {
                    exempleSpan_1.style.display = 'inline';
                }
                else {
                    exempleSpan_1.style.display = 'none';
                }
            };
            // Mets à jour l'affichage de l'exemple quand on change de radio
            inputTypeRadios.forEach(function (radio) {
                radio.addEventListener('change', toggleExemple_1);
            });
            // Mets à jour l'affichage au chargement
            toggleExemple_1();
            geocodeAndUpdateField();
            $('#id_latitude_coordonnate, #id_longitude_coordonnate').on('input', function () {
                geocodeAndUpdateField();
            });
        }
    });
};
